<template>
    <div class="emocat">
        <div class="fchat-search-emoji">
          <input type="text" id="search-emoji" placeholder="Search by name" name="id" class="" v-model="search_emoji" @keydown="emojiHandler" @keyup="emojiHandler">
        </div>
        <div class="fchat-emojis">
          <div v-for="(icon, index_icon) in this.icons" :key="index_icon" class="visibleChar"><input type="text" :value="icon.value" :title="icon.title" readonly="" @click="selectIcon(icon.value)"></div>
      </div>
    </div>
</template>
<script>
export default {
  name: "Emoji",
  data() {
    return {
        search_emoji: '',
        search_emoji_result: [],
        nsend_text: this.send_text,
        icons: [
        {"value":"😀", "title":"Grinning Face"},
        {"value":"😁", "title":"Beaming Face With Smiling Eyes"},
        {"value":"😂", "title":"Face With Tears of Joy"},
        {"value":"🤣", "title":"Rolling on the Floor Laughing"},
        {"value":"😃", "title":"Grinning Face With Big Eyes"},
        {"value":"😄", "title":"Grinning Face With Smiling Eyes"},
        {"value":"😅", "title":"Grinning Face With Sweat"},
        {"value":"😆", "title":"Grinning Squinting Face"},
        {"value":"😉", "title":"Winking Face"},
        {"value":"😊", "title":"Smiling Face With Smiling Eyes"},
        {"value":"😋", "title":"Face Savoring Food"},
        {"value":"😎", "title":"Smiling Face With Sunglasses"},
        {"value":"😍", "title":"Smiling Face With Heart-Eyes"},
        {"value":"😘", "title":"Face Blowing a Kiss"},
        {"value":"😗", "title":"Kissing Face"},
        {"value":"😙", "title":"Kissing Face With Smiling Eyes"},
        {"value":"😚", "title":"Kissing Face With Closed Eyes"},
        {"value":"🙂", "title":"Slightly Smiling Face"},
        {"value":"🤗", "title":"Hugging Face"},
        {"value":"🤩", "title":"Star-Struck"},
        {"value":"🤔", "title":"Thinking Face"},
        {"value":"🤨", "title":"Face With Raised Eyebrow"},
        {"value":"😐", "title":"Neutral Face"},
        {"value":"😑", "title":"Expressionless Face"},
        {"value":"😶", "title":"Face Without Mouth"},
        {"value":"🙄", "title":"Face With Rolling Eyes"},
        {"value":"😏", "title":"Smirking Face"},
        {"value":"😣", "title":"Persevering Face"},
        {"value":"😥", "title":"Sad but Relieved Face"},
        {"value":"😮", "title":"Face With Open Mouth"},
        {"value":"🤐", "title":"Zipper-Mouth Face"},
        {"value":"😯", "title":"Hushed Face"},
        {"value":"😪", "title":"Sleepy Face"},
        {"value":"😫", "title":"Tired Face"},
        {"value":"😴", "title":"Sleeping Face"},
        {"value":"😌", "title":"Relieved Face"},
        {"value":"😛", "title":"Face With Tongue"},
        {"value":"😜", "title":"Winking Face With Tongue"},
        {"value":"😝", "title":"Squinting Face With Tongue"},
        {"value":"🤤", "title":"Drooling Face"},
        {"value":"😒", "title":"Unamused Face"},
        {"value":"😓", "title":"Downcast Face With Sweat"},
        {"value":"😔", "title":"Pensive Face"},
        {"value":"😕", "title":"Confused Face"},
        {"value":"🙃", "title":"Upside-Down Face"},
        {"value":"🤑", "title":"Money-Mouth Face"},
        {"value":"😲", "title":"Astonished Face"},
        {"value":"☹", "title":"Frowning Face"},
        {"value":"🙁", "title":"Slightly Frowning Face"},
        {"value":"😖", "title":"Confounded Face"},
        {"value":"😞", "title":"Disappointed Face"},
        {"value":"😟", "title":"Worried Face"},
        {"value":"😤", "title":"Face With Steam From Nose"},
        {"value":"😢", "title":"Crying Face"},
        {"value":"😭", "title":"Loudly Crying Face"},
        {"value":"😦", "title":"Frowning Face With Open Mouth"},
        {"value":"😧", "title":"Anguished Face"},
        {"value":"😨", "title":"Fearful Face"},
        {"value":"😩", "title":"Weary Face"},
        {"value":"🤯", "title":"Exploding Head"},
        {"value":"😬", "title":"Grimacing Face"},
        {"value":"😰", "title":"Anxious Face With Sweat"},
        {"value":"😱", "title":"Face Screaming in Fear"},
        {"value":"😳", "title":"Flushed Face"},
        {"value":"🤪", "title":"Zany Face"},
        {"value":"😵", "title":"Dizzy Face"},
        {"value":"😡", "title":"Pouting Face"},
        {"value":"😠", "title":"Angry Face"},
        {"value":"🤬", "title":"Face With Symbols on Mouth"},
        {"value":"😷", "title":"Face With Medical Mask"},
        {"value":"🤒", "title":"Face With Thermometer"},
        {"value":"🤕", "title":"Face With Head-Bandage"},
        {"value":"🤢", "title":"Nauseated Face"},
        {"value":"🤮", "title":"Face Vomiting"},
        {"value":"🤧", "title":"Sneezing Face"},
        {"value":"😇", "title":"Smiling Face With Halo"},
        {"value":"🤠", "title":"Cowboy Hat Face"},
        {"value":"🤡", "title":"Clown Face"},
        {"value":"🤥", "title":"Lying Face"},
        {"value":"🤫", "title":"Shushing Face"},
        {"value":"🤭", "title":"Face With Hand Over Mouth"},
        {"value":"🧐", "title":"Face With Monocle"},
        {"value":"🤓", "title":"Nerd Face"},
        {"value":"😈", "title":"Red Devil With Horns"},
        {"value":"👿", "title":"Red Devil Face With Horns"},
        {"value":"👹", "title":"Ogre"},
        {"value":"👺", "title":"Goblin"},
        {"value":"💀", "title":"Skull"},
        {"value":"👻", "title":"Ghost"},
        {"value":"👽", "title":"Alien"},
        {"value":"🤖", "title":"Robot Face"},
        {"value":"💩", "title":"Pile of Poo"},
				{"value":"👦", "title":"Boy"},
				{"value":"👶", "title":"Baby"},
				{"value":"👧", "title":"Girl"},
				{"value":"👨", "title":"Man"},
				{"value":"👩", "title":"Woman"},
				{"value":"👴", "title":"Old Man"},
				{"value":"👵", "title":"Old Woman"},
				{"value":"👾", "title":"Alien Monster"},
				{"value":"👮", "title":"Police Officer"},
				{"value":"🕵", "title":"Detective"},
				{"value":"💂", "title":"Guard"},
				{"value":"👷", "title":"Construction Worker"},
				{"value":"🤴", "title":"Prince"},
				{"value":"👸", "title":"Princess"},
				{"value":"👳", "title":"Person Wearing Turban"},
				{"value":"👲", "title":"Man With Chinese Cap"},
				{"value":"🧕", "title":"Woman With Headscarf"},
				{"value":"🧔", "title":"Bearded Person"},
				{"value":"👱", "title":"Blond-Haired Person"},
				{"value":"🤵", "title":"Man in Tuxedo"},
				{"value":"👰", "title":"Bride With Veil"},
				{"value":"🤰", "title":"Pregnant Woman"},
				{"value":"🤱", "title":"Breast-Feeding"},
				{"value":"👼", "title":"Baby Angel"},
				{"value":"🎅", "title":"Santa Claus"},
				{"value":"🤶", "title":"Mrs. Claus"},
				{"value":"🙍", "title":"Person Frowning"},
				{"value":"🙎", "title":"Person Pouting"},
				{"value":"🙅", "title":"Person Gesturing No"},
				{"value":"🙆", "title":"Person Gesturing OK"},
				{"value":"💁", "title":"Person Tipping Hand"},
				{"value":"🙋", "title":"Person Raising Hand"},
				{"value":"🙇", "title":"Person Bowing"},
				{"value":"🤦", "title":"Person Facepalming"},
				{"value":"🤷", "title":"Person Shrugging"},
				{"value":"💆", "title":"Person Getting Massage"},
				{"value":"💇", "title":"Person Getting Haircut"},
				{"value":"🚶", "title":"Person Walking"},
				{"value":"💃", "title":"Woman Dancing"},
				{"value":"🕺", "title":"Man Dancing"},
				{"value":"👯", "title":"People With Bunny Ears"},
				{"value":"🕴", "title":"Man in Suit Levitating"},
				{"value":"🗣", "title":"Speaking Head"},
				{"value":"👤", "title":"Bust in Silhouette"},
				{"value":"👥", "title":"Busts in Silhouette"},
				{"value":"👫", "title":"Man and Woman Holding Hands"},
				{"value":"👬", "title":"Two Men Holding Hands"},
				{"value":"👭", "title":"Two Women Holding Hands"},
				{"value":"💏", "title":"Kiss"},
				{"value":"👨", "title":"Kiss: Man, Man"},
				{"value":"👩", "title":"Kiss: Woman, Woman"},
				{"value":"💑", "title":"Couple With Heart"},
				{"value":"👪", "title":"Family"},
				{"value":"😺", "title":"Grinning Cat Face"},
				{"value":"😸", "title":"Grinning Cat Face With Smiling Eyes"},
				{"value":"😹", "title":"Cat Face With Tears of Joy"},
				{"value":"😻", "title":"Smiling Cat Face With Heart-Eyes"},
				{"value":"😼", "title":"Cat Face With Wry Smile"},
				{"value":"😽", "title":"Kissing Cat Face"},
				{"value":"🙀", "title":"Weary Cat Face"},
				{"value":"😿", "title":"Crying Cat Face"},
				{"value":"😾", "title":"Pouting Cat Face"},
				{"value":"🙈", "title":"See-No-Evil Monkey"},
				{"value":"🙉", "title":"Hear-No-Evil Monkey"},
				{"value":"🙊", "title":"Speak-No-Evil Monkey"},
				{"value":"💥", "title":"Collision"},
				{"value":"🐵", "title":"Monkey Face"},
				{"value":"🐒", "title":"Monkey"},
				{"value":"🦍", "title":"Gorilla"},
				{"value":"🐶", "title":"Dog Face"},
				{"value":"🐕", "title":"Dog"},
				{"value":"🐩", "title":"Poodle"},
				{"value":"🐺", "title":"Wolf Face"},
				{"value":"🦊", "title":"Fox Face"},
				{"value":"🐱", "title":"Cat Face"},
				{"value":"🐈", "title":"Cat"},
				{"value":"🦁", "title":"Lion Face"},
				{"value":"🐯", "title":"Tiger Face"},
				{"value":"🐴", "title":"Horse Face"},
				{"value":"🐎", "title":"Horse"},
				{"value":"🦄", "title":"Unicorn Face"},
				{"value":"🦓", "title":"Zebra"},
				{"value":"🐮", "title":"Cow Face"},
				{"value":"🐄", "title":"Cow"},
				{"value":"🐷", "title":"Pig Face"},
				{"value":"🐖", "title":"Pig"},
				{"value":"🐗", "title":"Boar"},
				{"value":"🐽", "title":"Pig Nose"},
				{"value":"🐪", "title":"Camel"},
				{"value":"🐫", "title":"Two-Hump Camel"},
				{"value":"🦒", "title":"Giraffe"},
				{"value":"🐘", "title":"Elephant"},
				{"value":"🦏", "title":"Rhinoceros"},
				{"value":"🐇", "title":"Rabbit"},
				{"value":"🐿", "title":"Chipmunk"},
				{"value":"🦔", "title":"Hedgehog"},
				{"value":"🦇", "title":"Bat"},
				{"value":"🐼", "title":"Panda Face"},
				{"value":"🐾", "title":"Paw Prints"},
				{"value":"🦃", "title":"Turkey"},
				{"value":"🐔", "title":"Chicken"},
				{"value":"🐓", "title":"Rooster"},
				{"value":"🐥", "title":"Front-Facing Baby Chick"},
				{"value":"🐦", "title":"Bird"},
				{"value":"🦆", "title":"Duck"},
				{"value":"🦉", "title":"Owl"},
				{"value":"🐸", "title":"Frog Face"},
				{"value":"🐊", "title":"Crocodile"},
				{"value":"🐢", "title":"Turtle"},
				{"value":"🦕", "title":"Sauropod"},
				{"value":"🦖", "title":"T-Rex"},
				{"value":"🐳", "title":"Spouting Whale"},
				{"value":"🐋", "title":"Whale"},
				{"value":"🐬", "title":"Dolphin"},
				{"value":"🐟", "title":"Fish"},
				{"value":"🐠", "title":"Tropical Fish"},
				{"value":"🐡", "title":"Blowfish"},
				{"value":"🦈", "title":"Shark"},
				{"value":"🐙", "title":"Octopus"},
				{"value":"🐚", "title":"Spiral Shell"},
				{"value":"🦀", "title":"Crab"},
				{"value":"🦐", "title":"Shrimp"},
				{"value":"🦑", "title":"Squid"},
				{"value":"🐌",  "title":"Snail"},
				{"value":"🦋", "title":"Butterfly"},
				{"value":"🐛", "title":"Bug"},
				{"value":"🐜", "title":"Ant"},
				{"value":"🐝", "title":"Honeybee"},
				{"value":"🐞", "title":"Lady Beetle"},
				{"value":"🦗", "title":"Cricket"},
				{"value":"👞", "title":"Man’s Shoe"},
				{"value":"👑", "title":"Crown"},
				{"value":"👒", "title":"Woman’s Hat"},
				{"value":"🎩", "title":"Top Hat"},
				{"value":"🎓", "title":"Graduation Cap"},
				{"value":"🧢", "title":"Billed Cap"},
				{"value":"⛑", "title":"Rescue Worker’s Helmet"},
				{"value":"💄", "title":"Lipstick"},
				{"value":"💍", "title":"Ring"},
				{"value":"🌂", "title":"Closed Umbrella"},
				{"value":"☂", "title":"Umbrella"},
				{"value":"💼", "title":"Briefcase"},
				{"value":"🛀", "title":"Person Taking Bath"},
				{"value":"🛌", "title":"Person in Bed"},
				{"value":"💌", "title":"Love Letter"},
				{"value":"💣", "title":"Bomb"},
				{"value":"🚥", "title":"Horizontal Traffic Light"},
				{"value":"🚦", "title":"Vertical Traffic Light"},
				{"value":"🚧", "title":"Construction"},
				{"value":"🔪", "title":"Kitchen Knife"},
				{"value":"🏺", "title":"Amphora"},
				{"value":"💈", "title":"Barber Pole"},
				{"value":"🛢", "title":"Oil Drum"},
				{"value":"🛎", "title":"Bellhop Bell"},
				{"value":"⌛", "title":"Hourglass Done"},
				{"value":"⏳", "title":"Hourglass Not Done"},
				{"value":"⌚", "title":"Watch"},
				{"value":"⏰", "title":"Alarm Clock"},
				{"value":"⏱", "title":"Stopwatch"},
				{"value":"⏲", "title":"Timer Clock"},
				{"value":"🕰", "title":"Mantelpiece Clock"},
				{"value":"🌡", "title":"Thermometer"},
				{"value":"🎈", "title":"Balloon"},
				{"value":"📻", "title":"Radio"},
				{"value":"📱", "title":"Mobile Phone"},
				{"value":"📲", "title":"Mobile Phone With Arrow"},
				{"value":"☎", "title":"Telephone"},
				{"value":"📞", "title":"Telephone Receiver"},
				{"value":"📟", "title":"Pager"},
				{"value":"📠", "title":"Fax Machine"},
				{"value":"🔋", "title":"Battery"},
				{"value":"🔌", "title":"Electric Plug"},
				{"value":"💻", "title":"Laptop Computer"},
				{"value":"💽", "title":"Computer Disk"},
				{"value":"💾", "title":"Floppy Disk"},
				{"value":"💿", "title":"Optical Disk"},
				{"value":"📺", "title":"Television"},
				{"value":"📷", "title":"Camera"},
				{"value":"📹", "title":"Video Camera"},
				{"value":"📼", "title":"Videocassette"},
				{"value":"🔍", "title":"Magnifying Glass Tilted Left"},
				{"value":"💡", "title":"Light Bulb"},
				{"value":"🔦", "title":"Flashlight"},
				{"value":"🏮", "title":"Red Paper Lantern"},
				{"value":"📔", "title":"Notebook With Decorative Cover"},
				{"value":"📕", "title":"Closed Book"},
				{"value":"📚", "title":"Books"},
				{"value":"📓", "title":"Notebook"},
				{"value":"📑", "title":"Bookmark Tabs"},
				{"value":"💸", "title":"Money With Wings"},
				{"value":"📩", "title":"Envelope With Arrow"},
				{"value":"📤", "title":"Outbox Tray"},
				{"value":"📥", "title":"Inbox Tray"},
				{"value":"📦", "title":"Package"},
				{"value":"📮", "title":"Postbox"},
				{"value":"🗳", "title":"Ballot Box With Ballot"},
				{"value":"✏", "title":"Pencil"},
				{"value":"✎", "title":"Pencil"},
				{"value":"📝", "title":"Memo"},
				{"value":"📁", "title":"File Folder"},
				{"value":"📂", "title":"Open File Folder"},
				{"value":"🗂", "title":"Card Index Dividers"},
				{"value":"📅", "title":"Calendar"},
				{"value":"📆", "title":"Tear-Off Calendar"},
				{"value":"📇", "title":"Card Index"},
				{"value":"📈", "title":"Chart Increasing"},
				{"value":"📉", "title":"Chart Decreasing"},
				{"value":"📊", "title":"Bar Chart"},
				{"value":"📋", "title":"Clipboard"},
				{"value":"📌", "title":"Pushpin"},
				{"value":"📍", "title":"Round Pushpin"},
				{"value":"🔒", "title":"Locked"},
				{"value":"🔓", "title":"Unlocked"},
				{"value":"🔐", "title":"Locked With Key"},
				{"value":"🔑", "title":"Key"},
				{"value":"💘", "title":"Heart With Arrow"},
				{"value":"❤", "title":"Red Heart"},
				{"value":"💓", "title":"Beating Heart"},
				{"value":"💔", "title":"Broken Heart"},
				{"value":"💕", "title":"Two Hearts"},
				{"value":"💖", "title":"Sparkling Heart"},
				{"value":"💗", "title":"Growing Heart"},
				{"value":"💙", "title":"Blue Heart"},
				{"value":"💚", "title":"Green Heart"},
				{"value":"💝", "title":"Heart With Ribbon"},
				{"value":"💞", "title":"Revolving Hearts"},
				{"value":"💟", "title":"Heart Decoration"},
				{"value":"💦", "title":"Sweat Droplets"},
				{"value":"💨", "title":"Dashing Away"},
				{"value":"🏁", "title":"Chequered Flag"},
				{"value":"🚩", "title":"Triangular Flag"},
				{"value":"🎌", "title":"Crossed Flags"},
				{"value":"🏴", "title":"Black Flag"},
        ]
    }
  },
  props: {
        send_text: String
    },
  watch: {
        send_text: function () {
        this.nsend_text= this.send_text
        },
    },
  methods: {
    emojiHandler(e) {
        var aicons = this.search_emoji_result;
        let resulticon = [];
        aicons.forEach((list) => {
          if (list.title.toLocaleLowerCase().search(this.search_emoji.toLocaleLowerCase()) > -1) {
              resulticon.push(list)
          }
      })
      this.icons = resulticon;
    },
    selectIcon(event) {
        this.$emit('closeiconUpdated', false);
        this.$emit('iconUpdated', this.nsend_text + event);
    }
  },
  created() {
    this.search_emoji_result = this.icons;
  }
}
</script> 